// Shapes must match @sphtech/web2-ads globalExtensions.d.ts exactly —
// TypeScript requires identical types when Window declarations merge.
declare global {
  interface Window {
    OBR?: {
      extern?: {
        researchWidget?: () => void;
      };
    };
    outbrain_enable?: number | string | boolean;
  }
}

import { configGAM } from "@pub/config";
import { loadScript } from "@sphtech/dmg-design-system";
import React, { memo, useEffect, useRef } from "react";

const OutbrainScript: React.FC<{ url: string; useAlternateId?: boolean }> = ({
  url,
  useAlternateId = false,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    void Promise.all([
      new Promise((resolve) => {
        if (window.outbrain_enable !== undefined) {
          resolve(window.outbrain_enable);
          return;
        }
        const onMessage = (event: MessageEvent) => {
          if (event.origin !== window.origin) return;
          if (event.data === "outbrain_enable") {
            resolve(window.outbrain_enable);
            window.removeEventListener("message", onMessage);
          }
        };
        window.addEventListener("message", onMessage);
      }),
      loadScript("https://widgets.outbrain.com/outbrain.js", true),
    ]).then(([enabled]) => {
      const container = ref.current;
      if (
        !enabled ||
        !container ||
        // only add once, e.g. in react strict mode
        container.childNodes.length !== 0
      ) {
        return;
      }
      const outbrainIds = useAlternateId
        ? (configGAM.outbrainIdsAlt ?? ["AR_2"])
        : (configGAM.outbrainIds ?? ["AR_1"]);
      outbrainIds.forEach((obId) => {
        const outbrainDiv = document.createElement("div");
        outbrainDiv.className = "OUTBRAIN";
        outbrainDiv.setAttribute("data-src", url);
        outbrainDiv.setAttribute("data-widget-id", obId);
        container.appendChild(outbrainDiv);
      });
      window.OBR?.extern?.researchWidget?.();
    });
  }, [url, useAlternateId]);

  return (
    <div
      ref={ref}
      style={{
        order: 3,
      }}
    />
  );
};

export default memo(OutbrainScript);
